import React from "react";
import Slider from "react-slick";
import {
  SchorlarshipCard,
  SchorlarshipWrapper,
  NavLink,
} from "./Schorlarship.style";

export const Scholarship = () => {
  var settings = {
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 4000,
    vertical: true,
  };
  return (
    <>
      <SchorlarshipWrapper>
        <p>Reasons to opt in now and start bonpellzing</p>
        <h1>
          <div>
            <Slider {...settings}>
              <div>Scholarship for <span>Kids.</span></div>
              <div>Massive <span>incentives</span> for <span>Parents.</span></div>
              <div>Annual <span>travels</span> and <span>tours</span> for lucky <span>families.</span></div>
              <div>Flexibility, simplicity and fun with savings.</div>
              <div>Third party savings plan activation.</div>
              <div>Easy to hit target goals.</div>
              <div>Bonpellz Enabler (Overdraft).</div>
              <div>Bonpellz ultimate goals.</div>
              <div>Bonpellz solves real problems.</div>
              <div>Bonpellz's AWESOME? Opt in Now!!!.</div>
            </Slider>
          </div>
        </h1>
        <SchorlarshipCard>
          <p>
            We all can achieve <span>financial freedom</span> only if we could
            understand money better, manage our finances, save responsibly and
            invest meaningfully to start growing wealth right away, here is the
            best and right place to achieve it all
          </p>
          <NavLink to="">Get early access now</NavLink>
        </SchorlarshipCard>
      </SchorlarshipWrapper>
    </>
  );
};
